__turbopack_context__.v({
  "filter": "togglingFilters-module-scss-module__mPK2rq__filter",
  "filterItemButton": "togglingFilters-module-scss-module__mPK2rq__filterItemButton",
  "filterItemRestricted": "togglingFilters-module-scss-module__mPK2rq__filterItemRestricted",
  "filtersWrapper": "togglingFilters-module-scss-module__mPK2rq__filtersWrapper",
  "firstButton": "togglingFilters-module-scss-module__mPK2rq__firstButton",
  "isActive": "togglingFilters-module-scss-module__mPK2rq__isActive",
  "isDisabled": "togglingFilters-module-scss-module__mPK2rq__isDisabled",
});
